/** модальное окно для выбора локализаций в требуемых случаях */
import _ from "lodash";
import React from "react";
import { connect } from "react-redux";
import IntlMessages from "util/intlMessages";
import { adminAPI } from "redux/api";
import { FloatModal } from "components/special";

const { api } = adminAPI.actions;

const FloatAssistantsModal = (props) => {
  return (
    <FloatModal
      header={<IntlMessages id="OpenAI.Assistants" />}
      {...props}
      head={(search, searchQuery, setSearchQuery) => {
        return (
          <>
            <th>
              <IntlMessages id="name" />
            </th>
            <th style={{ width: "30px" }}></th>
          </>
        );
      }}
      row={(value, clickHandler) => (
        <>
          <td onClick={clickHandler} className={!value.enabled ? "text-strike" : ""}>
            {value.name}
          </td>
          <td></td>
        </>
      )}
    />
  );
};

const FloatAssistants = (props) => {
  return <FloatAssistantsModal {...props} />;
};
export default connect(null, {
  getData: api.get("/api/openai/assistants"),
})(FloatAssistants);
